import React from "react";

import { Div } from "components/Base";
import SearchBar from "ui-kit/SearchBar/View";

import { SEARCH_BAR_INSTANCE_ID_CALENDAR_SECTION } from "../constants";
import { connect } from "react-redux";
import { getBackgroundColor } from "Portal/NewPortal/PortalHome/selectors";

const decorate = connect(
  state => ({
    backgroundColor: getBackgroundColor(state)
  }),
  {}
);

const Toolbar = ({ backgroundColor }) => {
  return (
    <Div
      display="column.center.flex-start"
      mb={4}
      width={1}
      style={{ gap: "16px" }}
    >
      <div
        style={{
          color: "#494949",
          fontSize: "20px",
          fontWeight: "600"
        }}
      >
        Calendar
      </div>
      <Div width={1}>
        <SearchBar
          instanceId={SEARCH_BAR_INSTANCE_ID_CALENDAR_SECTION}
          flex={1}
          mr={0}
          placeholder={"Search Event ..."}
          height={36}
          {...(backgroundColor ? { bg: backgroundColor } : {})}
        />
      </Div>
    </Div>
  );
};

export default decorate(Toolbar);
